module.exports = __webpack_public_path__ + "img/logo_white.17b7e0df.png";